// extracted by extract-css-chunks-webpack-plugin
module.exports = {"quick-add-to-cart":"yc07i"};